import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ProfileInterface {
  id: number;
  legal_name: string;
  preferred_name: string;
  email: string;
  ph_country_code: string;
  phone_number: string;
  wh_country_code: string;
  whatsapp_number: string;
  identify_as: number;
  identify_as_other: string;
  pronoun: string;
  current_location: number;
  prefered_location: number;
  current_profile_role: string;
  current_previous_company: string;
  total_experience_months: number;
  total_experience_years: number;
  highest_education: string;
  highest_education_passing_month: number;
  highest_education_passing_year: number;
  annual_package: number;
  current_salary: number;
  out_at_work: number;
  source_details: string;
  additional_information: string;
  interested_in_internships: number;
  over_eighteen_years: number;
  internship_available_months: string;
  aggregate_percentage: string;
  shared_with_circle_identity_as_lgbt: number;
  about_yourself: string;
  date_of_birth: string;
  current_state: number;
  country_name: number;
  how_did_you_know: string;
  industry: number;
  institution_name: string;
  lgbt_status: number;
  candidate_status: number;
  resume_file: string;
  redacted_resume: string;
  created_by: number;
  created_at: string;
  updated_at: string;
  published: string;
  identify_name: string;
  city_name: string;
  skills: string;
  skills_name: string;
  out_at_work_name: string;
  interested_in_internships_name: string;
  over_eighteen_years_name: string;
  shared_with_circle_identity_as_lgbt_name: string;
  education_passing_year_name: string;
  current_salary_name: string;
  total_experience_name: string;
}

export interface AuthState {
  isAuth: boolean;
  profile: ProfileInterface;
  token: string;
}

const initialState: AuthState = {
  isAuth: false,
  profile: null,
  token: null,
  is_job_fair_live: false,
  job_fair_banner: "",
  job_fair_title:"",
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    actionAuth: (state, action: PayloadAction<AuthState>) => {
      state.isAuth = true;
      state.profile = action.payload.data;
      state.token = action.payload.token;
      state.is_job_fair_live = action.payload.is_job_fair_live;
      state.job_fair_banner = action.payload.job_fair_banner;
      state.job_fair_id = action.payload.job_fair_id;
      state.job_fair_title = action.payload.job_fair_title;
    },
    actionProfile: (state, action: PayloadAction<ProfileInterface>) => {
      state.profile = action.payload;
      state.is_job_fair_live = action.payload.is_job_fair_live;
      state.job_fair_banner = action.payload.job_fair_banner;
      state.job_fair_id = action.payload.job_fair_id;
      state.job_fair_title = action.payload.job_fair_title;
    },
    actionLogout: (state) => {
      localStorage.removeItem("candidate");
      state.isAuth = false;
      state.profile = null;
      state.token = null;
      state.is_job_fair_live = false;
      state.job_fair_banner = "";
      state.job_fair_id = "";
      state.job_fair_title = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const { actionAuth, actionProfile, actionLogout } = AuthSlice.actions;

export default AuthSlice.reducer;
